import { computed } from 'vue';
import { useDayStore } from '@/rennovation/planning-view/store/useDayStore';
import { PLANNING_DAY_STATUS } from '@/rennovation/planning-view/constants';

export function usePlanningDayStatus(data, daysRef) {
	const dayStore = useDayStore();
	const isPastOrPublishedDay = computed(() => {
		const day = data.value?.day;

		if (!day || !daysRef) {
			return false;
		}

		const status = dayStore.getDayStatus(daysRef[day]);

		return [PLANNING_DAY_STATUS.PAST, PLANNING_DAY_STATUS.PUBLISHED].includes(status);
	});

	const assignDutyPropertyFixed = (day) => {
		return [PLANNING_DAY_STATUS.PAST, PLANNING_DAY_STATUS.PUBLISHED].includes(dayStore.getDayStatus(day));
	};

	return {
		isPastOrPublishedDay,
		assignDutyPropertyFixed,
	};
}
